import { useState } from 'react';
import { useNavigate } from 'react-router';
import { Elements } from '@/components';

export const Pricing = () => {
    const [billingPeriod, setBillingPeriod] = useState<'monthly' | 'yearly'>('monthly');
    const navigate = useNavigate();

    return (
        <section className="overflow-hidden bg-cover bg-center bg-no-repeat px-5 pt-20 pb-20 md:px-10 lg:px-[79px]">
            <div className="mx-auto flex w-full max-w-[1200px] flex-col items-center justify-between gap-4">
                <div className="mb-10 flex flex-col items-center justify-center gap-4">
                    <Elements.Title title="Pricing" type="h1" className="text-center text-gray-900" />
                    <Elements.Description
                        description="Platform licensing has two components."
                        type="medium"
                        className="w-full max-w-[450px] text-left text-gray-900"
                    />
                </div>


                <div className="flex w-full max-w-[1200px] flex-col items-start justify-between gap-4 rounded-3xl bg-brand-50 p-10 border border-brand-100">
                    <div className="flex flex-col items-start justify-start gap-2">
                        <Elements.Title
                            title="Per (Enrolled) Employee Per Month (PEPM) Pricing"
                            type="h4"
                            className="text-start text-gray-900"
                        />
                    </div>

                    <div className="grid w-full grid-cols-1 gap-4 md:grid-cols-2">
                        <Elements.PricingCard
                            title="Core"
                            description="Standard employee licensing"
                            price="$5"
                            priceLabel="PEPM"
                            features={[
                                'Streamlined plan setup and configuration',
                                'Employee enrollment management tools',
                                'Real-time reporting and analytics dashboard',
                                'Automated compliance documentation',
                            ]}
                        />
                        <Elements.PricingCard
                            title="Core+Cobra"
                            description="Add COBRA"
                            price="$5.75"
                            priceLabel="PEPM"
                            features={[
                                'Streamlined plan setup and configuration',
                                'Employee enrollment management tools',
                                'Real-time reporting and analytics dashboard',
                                'Automated compliance documentation',
                                'COBRA Administration',
                            ]}
                        />
                    </div>
                </div>

                <div className="flex w-full max-w-[1200px] flex-col items-center justify-between gap-4 rounded-3xl border border-brand-100 bg-brand-50 p-10 lg:flex-row lg:items-center">
                    <div className="flex w-full flex-col items-start justify-start gap-4 lg:max-w-[350px]">
                        <Elements.Title title="Platform Pricing" type="h2" className="text-center text-gray-900" />
                        <Elements.Description
                            description="For any Agency, Brokerage, TPA, PEO or Solo Broker."
                            type="medium"
                            className="text-left text-gray-900"
                        />

                        <div className="">
                            <div className="mb-4 flex items-center justify-start gap-3">
                                <div className="inline-flex items-center gap-2">
                                    <button
                                        onClick={() => setBillingPeriod('monthly')}
                                        className={`text-sm font-medium transition-colors ${billingPeriod === 'monthly' ? 'text-gray-900' : 'text-gray-400'
                                            }`}
                                    >
                                        Monthly
                                    </button>
                                    <button
                                        type="button"
                                        onClick={() =>
                                            setBillingPeriod(billingPeriod === 'monthly' ? 'yearly' : 'monthly')
                                        }
                                        className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:outline-none ${billingPeriod === 'yearly' ? 'bg-blue-600' : 'bg-gray-300'
                                            }`}
                                    >
                                        <span
                                            className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${billingPeriod === 'yearly' ? 'translate-x-6' : 'translate-x-1'
                                                }`}
                                        />
                                    </button>
                                    <button
                                        onClick={() => setBillingPeriod('yearly')}
                                        className={`text-sm font-medium transition-colors ${billingPeriod === 'yearly' ? 'text-gray-900' : 'text-gray-400'
                                            }`}
                                    >
                                        Yearly
                                    </button>
                                </div>

                                <span className="inline-flex items-center rounded-full bg-green-100 px-3 py-1 text-xs font-medium text-green-800">
                                    Save 13%
                                </span>
                            </div>
                        </div>
                    </div>

                    <div className="grid w-full grid-cols-1 gap-4 md:grid-cols-2 lg:max-w-[850px]">
                        {/* <Elements.LicenseCard
                            title="Solo Broker License"
                            price={billingPeriod === 'yearly' ? '$300/year' : '$29/month'}
                            features={[
                                'ACA Affordability Analysis',
                                'ICHRA Plan Builder',
                                'Unlimited Employers',
                                'Unlimited Employees',
                            ]}
                            onButtonClick={() => navigate('/demo')}
                        /> */}
                        <Elements.LicenseCard
                            title="Organization License"
                            price={billingPeriod === 'yearly' ? '$1,000/year' : '$95/month'}
                            features={[
                                'Unlimited Agencies',
                                'Unlimited Brokers/Reps',
                                'Unlimited Employers',
                                'Unlimited Employees',
                            ]}
                            onButtonClick={() => navigate('/demo')}
                        />
                    </div>
                </div>
            </div>
        </section>
    );
};
